/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react'
import {
  Link as StyledLink,
  LinkProps as StyledLinkProps,
} from '@gousto-internal/citrus-react'
import { Link as ReactRouterLink } from 'react-router-dom'
import {
  getRouteURL,
  isExternal,
  RouteURLParams,
  Route,
} from '../../common/routing'

type SharedProps = Omit<StyledLinkProps, 'href'>

type BaseLinkProps = Omit<ReactRouterLink, 'href' | 'children' | '$$typeof'>

type LinkForRouteProps<R extends Route> = Omit<SharedProps & BaseLinkProps & RouteURLParams<R>, 'href'>

type LinkProps = SharedProps & ({ href: string } | BaseLinkProps)

type LinkForReactRouterProps = LinkProps & { navigate: string }

const LinkForReactRouter = (
  { navigate, ...rest }: LinkForReactRouterProps,
) => <StyledLink {...rest} />

export const Link = <R extends Route | undefined = undefined>
  (props: R extends Route ? LinkForRouteProps<R> : LinkProps) => {
  if ('href' in props) {
    return <StyledLink {...props} />
  }

  const {
    route,
    routeParams,
    queryParams,
    ...rest
  } = props as LinkForRouteProps<R extends Route ? R : never>

  const isExternalRoute = isExternal(route)
  const href = getRouteURL({
    route,
    routeParams,
    queryParams,
    absolute: isExternalRoute,
  })

  if (isExternalRoute) {
    return <StyledLink {...rest} href={href} />
  }

  return (<ReactRouterLink to={href} component={LinkForReactRouter} {...rest} />)
}
